'use strict';
import angular from 'angular';
var BrandAgreementsController = /** @class */ (function () {
    /*@ngInject*/
    function BrandAgreementsController($log, $scope, $mdDialog, $q, $sce, BrandAgreementsService, seoMetaService) {
        this.sortType = 'description'; // set the default sort type
        this.sortReverse = false; // set the default sort order
        this.searchBrandName = ''; // set the default search/filter term
        this.completeBrandAgreements = [];
        this.allPromises = [];
        // set the default amount of items being displayed
        this.limit = 10;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'BrandAgreementsController');
        this.brandAgreementsService = BrandAgreementsService;
        this.$mdDialog = $mdDialog;
        this.$q = $q;
        this.$log = $log;
        this.$sce = $sce;
        this.$scope = $scope;
        this.$scope.showButtons = {
            cancel: true,
            agree: true,
            sendMail: false,
            status: false,
            ok: false
        };
        var self = this;
        self.setBrandAgreementWarningContent();
        self.deferred1 = this.$q.defer();
        self.deferred2 = this.$q.defer();
        self.allPromises.push(self.deferred1.promise);
        self.allPromises.push(self.deferred2.promise);
        this.brandAgreementsService.getAllBrandAgreements().then(function (data) {
            self.$log.debug('Received All BrandAgreements -> ', data);
            self.brandAgreements = data.currentPage;
            self.deferred1.resolve();
        });
        this.brandAgreementsService.getBrandAgreementsForAccount().then(function (data) {
            self.$log.debug('Received BrandAgreements For Account -> ', data);
            self.brandAgreementsAcct = data.currentPage;
            self.deferred2.resolve();
        });
        self.$q.all(self.allPromises).then(function () {
            self.refreshBrandAgreementsAccountList();
        });
        self.setButtonsInPopup('Initial');
    }
    BrandAgreementsController.prototype.setBrandAgreementWarningContent = function () {
        this.brandAgreementContentPara1 = "Many of the brands Emerson Ecologics represents are formulated specifically\n      for healthcare professionals and are not available through online or conventional\n      retailers. Emerson Ecologics respects and shares the beliefs of our professional\n      brand partners that the guidance of a qualified healthcare practitioner is important\n      to maximize the effectiveness of professional strength supplements. In view of this\n      we fully support the resale policies and restrictions of our suppliers.<br /><br />The\n      brands listed below have their own internet reseller policies and require agreement\n      with this specific policy prior to gaining access to their products. You may read\n      and agree to these policies by clicking the brand name and confirming your\n      acceptance of the policy.<br /><br />Some brand agreements may require an electronic\n      signature versus an electronic acknowledgement.";
    };
    BrandAgreementsController.prototype.canViewAgreement = function (brand) {
        if (brand.brandCode === 'DFH' || brand.brandCode === 'OHM' || brand.brandCode == 'KL') {
            if (brand.downloadUrl != null) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };
    BrandAgreementsController.prototype.setButtonsInPopup = function (stage) {
        console.log('Setting Buttons ->', stage);
        switch (stage) {
            case 'Initial':
                this.$scope.showButtons.cancel = true;
                this.$scope.showButtons.agree = true;
                this.$scope.showButtons.sendMail = false;
                this.$scope.showButtons.status = false;
                this.$scope.showButtons.agreementComplete = false;
                this.$scope.showButtons.ok = false;
                break;
            case 'CancelMail':
                this.$scope.showButtons.cancel = true;
                this.$scope.showButtons.agree = false;
                this.$scope.showButtons.sendMail = true;
                this.$scope.showButtons.status = false;
                this.$scope.showButtons.agreementComplete = false;
                this.$scope.showButtons.ok = false;
                break;
            case 'StatusMail':
                this.$scope.showButtons.cancel = false;
                this.$scope.showButtons.agree = false;
                this.$scope.showButtons.sendMail = false;
                this.$scope.showButtons.status = true;
                this.$scope.showButtons.agreementComplete = false;
                this.$scope.showButtons.ok = true;
                break;
            case 'StatusCancelMail':
                this.$scope.showButtons.cancel = true;
                this.$scope.showButtons.agree = false;
                this.$scope.showButtons.sendMail = true;
                this.$scope.showButtons.status = true;
                this.$scope.showButtons.agreementComplete = false;
                this.$scope.showButtons.ok = false;
                break;
            case 'StatusOk':
                this.$scope.showButtons.cancel = false;
                this.$scope.showButtons.agree = false;
                this.$scope.showButtons.sendMail = false;
                this.$scope.showButtons.status = false;
                this.$scope.showButtons.agreementComplete = true;
                this.$scope.showButtons.ok = true;
                break;
        }
    };
    BrandAgreementsController.prototype.refreshBrandAgreementsAccountList = function () {
        var self = this;
        var found = false;
        for (var i = 0; i < self.brandAgreements.length; i++) {
            found = false;
            self.completeBrandAgreements[i] = {};
            self.completeBrandAgreements[i].brandAgreementId = self.brandAgreements[i].brandAgreementId;
            self.completeBrandAgreements[i].description = self.brandAgreements[i].description;
            self.completeBrandAgreements[i].brandAgreementText = self.$sce.trustAsHtml(self.brandAgreements[i].brandAgreementText);
            for (var j = 0; j < self.brandAgreementsAcct.length; j++) {
                if (self.brandAgreementsAcct[j].brandCode == self.brandAgreements[i].brandAgreementTypeId) {
                    self.completeBrandAgreements[i].agreementTypeKey = self.brandAgreementsAcct[j].agreementTypeKey;
                    self.completeBrandAgreements[i].agreed = self.brandAgreementsAcct[j].agreed;
                    self.completeBrandAgreements[i].brandCode = self.brandAgreementsAcct[j].brandCode;
                    if (self.completeBrandAgreements[i].agreed) {
                        self.completeBrandAgreements[i].agreedDate = self.brandAgreementsAcct[j].agreedDate;
                    }
                    self.completeBrandAgreements[i].status = self.brandAgreementsAcct[j].status;
                    self.completeBrandAgreements[i].docusignDocumentUrl = self.brandAgreementsAcct[j].docusignDocumentUrl;
                    self.completeBrandAgreements[i].downloadUrl = self.brandAgreementsAcct[j].docusignDocumentUrl;
                    found = true;
                    break;
                }
            }
            if (!found) {
                self.completeBrandAgreements[i].brandCode = self.brandAgreements[i].brandAgreementTypeId;
            }
        }
    };
    BrandAgreementsController.prototype.setAgreedDate = function (brand) {
        var self = this;
        var retResp;
        this.brandAgreementsService.signBrandAgreementsForBrandCode(brand).then(function (response) {
            if (response.status == 200 && response.data.errors.length <= 0) {
                self.completeBrandAgreements = self.completeBrandAgreements.filter(function (x) {
                    if (x.brandCode !== 'DFH' && x.brandCode !== 'OHM' && x.brandCode !== 'KL' && x.brandCode == brand.brandCode) {
                        if (response.data.response.agreed) {
                            x.agreed = response.data.response.agreed;
                            x.agreedDate = response.data.response.agreedDate;
                        }
                    }
                    if ((x.brandCode === 'DFH' || x.brandCode === 'OHM' || x.brandCode === 'KL') && x.brandCode == brand.brandCode) {
                        if (response.data.response.agreed) {
                            x.agreed = response.data.response.agreed;
                            x.agreedDate = response.data.response.agreedDate;
                        }
                        x.status = response.data.response.status;
                        x.docusignDocumentUrl = response.data.response.docusignDocumentUrl;
                        x.downloadUrl = response.data.response.docusignDocumentUrl;
                        //x.downloadUrl = 'http://localhost:9000/';
                        //x.status = 'Agreement Sent to you on 11/11/1900. Please review and approve'; // Status & ok
                        //x.status = 'Pending Emerson review and approval'; // status & ok
                        //x.status = 'Previous submission declined, please re-submit'; // status, cancel , mail
                        //x.status = 'Agreement Sent to you on 11/11/1900. Please review and agree';
                    }
                    return true;
                });
                return retResp = response.data.response;
            }
        });
        return retResp;
    };
    BrandAgreementsController.prototype.answer = function ($event, answer, brand) {
        $event.preventDefault();
        var retResp;
        if (answer === 'Agree' || answer === 'Mail') {
            retResp = this.setAgreedDate(brand);
        }
        this.$mdDialog.hide(answer);
    };
    ;
    BrandAgreementsController.prototype.setButtons = function (brand) {
        var self = this;
        if (brand.brandCode === 'DFH' || brand.brandCode === 'OHM' || brand.brandCode === 'KL') {
            if (brand.agreed) {
                self.setButtonsInPopup('StatusOk');
            }
            else if (brand.status && brand.status.toLowerCase().indexOf('declined') != -1) {
                self.setButtonsInPopup('StatusCancelMail'); //DFH is denied
            }
            else if (brand.status) {
                self.setButtonsInPopup('StatusMail'); //DFH is pending approval
            }
            else {
                self.setButtonsInPopup('CancelMail'); //first time for DFH
            }
        }
        else {
            self.setButtonsInPopup('Initial');
        }
    };
    BrandAgreementsController.prototype.showAgreement = function (ev, templateName, _brand, _showButtons) {
        var self = this;
        self.$scope._brand = _brand;
        self.setButtons(_brand);
        //templateUrl: templateName,
        self.$mdDialog.show({
            controller: this.DialogController,
            resolve: {
                brand: function () {
                    return _brand;
                },
                showButtons: function () {
                    return _showButtons;
                }
            },
            contentElement: '#' + templateName,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        })
            .then(function (answer) { }, function () {
            self.$log.debug('You cancelled the dialog.');
        });
    };
    ;
    /*@ngInject*/
    BrandAgreementsController.prototype.DialogController = function ($scope, $mdDialog, brand, showButtons) {
        $scope._brand = brand;
        $scope.showButtons = showButtons;
        var self = this;
        $scope.hide = function () {
            console.log('In hide');
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            console.log('In Cancel');
            $mdDialog.cancel();
        };
    };
    return BrandAgreementsController;
}());
export default BrandAgreementsController;
//# sourceMappingURL=brand-agreements.controller.js.map